export default "/_next/static/chunks/fonts/Outfit SemiBold-ea851e9b6c1d21f620c13e7fabc2a097.ttf";